export const SLICE_NAME = 'peopleHappinessPage';
